import axios from 'axios';

/** @class */
export default class Login {
    static install = (Vue, options) => {
        Object.defineProperty(Vue.prototype, '$login', {
            get() {
                if (!this.$root._login) {
                    this.$root._login = new Login(options);
                }
                return this.$root._login;
            }
        });

        Vue.mixin({
            beforeCreate() {
                if (!this.$root._login) {
                    this.$root._login = new Login(options);
                }
            }
        });
    };

    /**
     * @constructor
     * @param config
     */
    constructor(config) {
        this.baseUrl_ = config.API.INVOKE_URL;
        this.currentUser_ = '';
        return this;
    }

    /**
     * username, passwordでログイン
     */
    login(username) {
        let self_ = this;
        return new Promise((resolve, reject) => {
            axios.post(
                `${self_.baseUrl_}login`,
                JSON.stringify({
                    email: username
                })
            ).then(
                function (res) {
                    self_.currentUser_ = res['data']['key'];
                    self_.setStorageUser(self_.currentUser_);
                    resolve(self_.currentUser_);
                }
            ).catch(
                function (err) {
                    reject(err);
                }
            );
        });
    }
    isSignIn() {
        return Boolean(this.getCurrentUser());
    }

    /**
     * Login中のUserを返却
     * @returns {String}
     */
    getCurrentUser() {
        if (this.currentUser_) {
            return this.currentUser_;
        }
        return this.getStorageUser();
    }

    getStorageUser() {
        try {
            let storageUser = localStorage.getItem(Login.STORAGE_KEY_);
            if (storageUser) {
                return storageUser;
            }
            return '';
        } catch (e) {
            return '';
        }
    }

    setStorageUser(user) {
        try {
            localStorage.setItem(Login.STORAGE_KEY_, user);
        } catch (e) {
        }
    }

    /**
     *
     * @returns {string}
     * @private
     */
    static get STORAGE_KEY_() {
        return 'rehaplan.stop_covid_19.user';
    }
};



// WEBPACK FOOTER //
// ./src/custom_plugins/auth/login.js